import React from 'react';
import styles from './PortalTabs.module.scss';

export interface TabDef {
  key: string;
  label: string;
  count?: number;
}

interface PortalTabsProps {
  tabs: TabDef[];
  activeTab: string;
  onTabChange: (key: string) => void;
}

export default function PortalTabs({ tabs, activeTab, onTabChange }: PortalTabsProps) {
  return (
    <div className={styles.tabs}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`${styles.tab} ${activeTab === tab.key ? styles.active : ''}`}
          onClick={() => onTabChange(tab.key)}
        >
          {tab.label}
          {tab.count !== undefined && <span className={styles.badge}>{tab.count}</span>}
        </button>
      ))}
    </div>
  );
}
